import React from "react"
import {Link} from "gatsby"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhoneAlt,faEnvelope,faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'

const Services = () => (
  <div className="contact-container" style={{color:"white"}}>
      <p className="align-middle" style={{color:"#ff4a57"}}>HAVE ANY QUERY ?</p>
      <h2 className="align-middle" style={{color:"#fff"}}><b>Contact Me</b></h2>
      <p className="align-middle" style={{color:"#dfdfdf"}}>Please feel free to reach out if you have any question and want to collab.</p>
      <ul className="align-middle" style={{marginLeft:"0px"}}>
        <li className="list-inline-item"><Link className="skills-button" to="/contact/#formlink">Contact Form <FontAwesomeIcon className="service-icons changeOn" icon={faArrowCircleRight} /></Link></li>
      </ul>
      <div className="row" style={{marginLeft:"20%"}}>
      <div className="col-md-6">
      <div className="contact-info row">
        <div>
          <FontAwesomeIcon className="contact-icons" icon={faPhoneAlt} size="2x" />
        </div>
        <div className="contact-text">
        <p style={{fontWeight:"bold"}}>Give me a call</p>
        <p>+91 75975 50171</p>
        </div>
      </div>
      </div>
      <div className="col-md-6">
      <div className="contact-info row">
        <div>
          <FontAwesomeIcon className="contact-icons" icon={faEnvelope} size="2x" />
        </div>
        <div className="contact-text">
        <p style={{fontWeight:"bold",textAlign:"left"}}>Get in online</p>
        <p>me.chiragjain@gmail.com</p>
        </div>
      </div>
      </div>
    </div>
  </div>
)

export default Services
